import { ChangeDetectionStrategy, Component, HostBinding, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { RippleModule } from 'primeng/ripple';
import { Authorities } from '@ipensii/shared/domain-shared';
import { ArrayUtils } from '@ipensii/shared/util-shared';

@Component({
  selector: 'ip-shared-dashboard-card',
  standalone: true,
  imports: [CommonModule, ButtonModule, RippleModule],
  templateUrl: 'dashboard-card.component.html',
  styleUrl: 'dashboard-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DashboardCardComponent implements OnInit {
  @Input({ required: true }) icon!: string;
  @Input({ required: true }) label!: string;
  @Input() userAuthorities: Array<Authorities> | undefined;
  @Input() requiredAuthorities: Array<Authorities> | undefined;
  @HostBinding('class') readonly hostClasses = 'card dashboard-card-host';
  @HostBinding('class.hidden') noAccess = true;

  ngOnInit() {
    this.noAccess =
      !!this.requiredAuthorities &&
      !!this.requiredAuthorities.length &&
      !ArrayUtils.includesAny(this.userAuthorities, this.requiredAuthorities);
  }
}
